import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

function updateViewportHeight(): void {
  const height = window.visualViewport?.height || window.innerHeight;
  document.documentElement.style.setProperty('--viewport-height', `${height}px`);
}

window.visualViewport?.addEventListener('resize', updateViewportHeight);
window.visualViewport?.addEventListener('scroll', updateViewportHeight);
window.addEventListener('resize', updateViewportHeight);

document.addEventListener('touchstart', (event) => {
  const target = event.target;

  if (
    target instanceof HTMLElement &&
    !target.closest("input, textarea, select, [contenteditable='true']")
  ) {
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
  }
});

document.addEventListener('focusin', (event) => {
  const target = event.target;

  if (
    target instanceof HTMLElement &&
    target.matches("input, textarea, select, [contenteditable='true']")
  ) {
    setTimeout(() => {
      target.scrollIntoView({
        block: 'center',
        behavior: 'smooth',
      });
    }, 250);
  }
});

updateViewportHeight();

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err)
);
